import { useTranslation } from 'react-i18next';


import { Helmet } from '@dr.pogodin/react-helmet';

import { PageTitle, PageTitleProps } from '@anyx/shared-ui';
import { useDocumentHead, useEnvironmentStore } from '@anyx/shared-utils';

interface CrmHeadProps extends Partial<PageTitleProps> {
  pageTitle?: string;
}

export const CrmHead = ({ text, aside, onBack, pageTitle }: CrmHeadProps) => {
  const { t } = useTranslation('shared');
  const appName = useEnvironmentStore((s) => s.appName);
  const crmName = t('shared.entity.crm', { count: 1, ns: 'shared' });

  const { documentTitle } = useDocumentHead({
    pageTitle: pageTitle || text,
    appName: `${crmName} | ${appName}`,
  });

  return (
    <>
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>
      {text && <PageTitle aside={aside} onBack={onBack} text={text} />}
    </>
  );
};
